import { inject, Injectable } from '@angular/core';
import { Hub } from 'aws-amplify/utils';
import { PosthogService } from "./posthog.service";

@Injectable({
  providedIn: 'root'
})
export class AmplifyAuthSubscriptionService  {
  private posthogService = inject(PosthogService)

  initializeSubscription(): void {
    Hub.listen('auth', ({ payload }) => {
      switch (payload.event) {
        case 'signedIn':
          this.posthogService.initializeForUser();
          console.log('user have been signedIn successfully.');
          break;
        case 'signedOut':
          console.log('user have been signedOut successfully.');
          break;
        case 'tokenRefresh':
          console.log('auth tokens have been refreshed.');
          break;
        case 'tokenRefresh_failure':
          console.log('failure while refreshing auth tokens.');
          break;
        case 'signInWithRedirect':
          this.posthogService.initializeForUser();
          console.log('signInWithRedirect API has successfully been resolved.');
          break;
        case 'signInWithRedirect_failure':
          console.log('failure while trying to resolve signInWithRedirect API.');
          break;
        case 'customOAuthState':
          console.info('custom state returned from CognitoHosted UI');
          break;
      }
    });
  }

}
